export const MENU_AVATAR_BACKGROUND = 'control';
export const MENU_AVATAR_COLOR = 'white';
export const ORGANIZATIONS_URL = '/organizations';
export const DEMO_TLDS = ['.com', '.ca', '.co.uk', '.ie', '.com.au', '.co.nz'];
